import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { webhooksApi } from '@/lib/api';

export function useWebhookEndpoints() {
  return useQuery({
    queryKey: ['webhooks', 'endpoints'],
    queryFn: () => webhooksApi.listEndpoints(),
  });
}

export function useCreateWebhookEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: webhooksApi.createEndpoint,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['webhooks'] });
    },
  });
}

export function useUpdateWebhookEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof webhooksApi.updateEndpoint>[1] }) =>
      webhooksApi.updateEndpoint(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['webhooks'] });
    },
  });
}

export function useDeleteWebhookEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: webhooksApi.deleteEndpoint,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['webhooks'] });
    },
  });
}

export function useWebhookDeliveries(endpointId: string) {
  return useQuery({
    queryKey: ['webhooks', 'deliveries', endpointId],
    queryFn: () => webhooksApi.getDeliveries(endpointId),
  });
}

export function useTestWebhookEndpoint() {
  return useMutation({
    mutationFn: webhooksApi.testEndpoint,
  });
}

export function useInboundTokens() {
  return useQuery({
    queryKey: ['webhooks', 'tokens'],
    queryFn: () => webhooksApi.listTokens(),
  });
}

export function useCreateInboundToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: webhooksApi.createToken,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['webhooks', 'tokens'] });
    },
  });
}

export function useDeleteInboundToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: webhooksApi.deleteToken,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['webhooks', 'tokens'] });
    },
  });
}
